export default function DateTime({date, setDate}: {date: string, setDate: React.Dispatch<React.SetStateAction<string>>}) {
    return <input
        type="text"
        placeholder="DD/MM/YYYY HH:MM"
        value={date}
        onChange={(event) => setDate(event.target.value)}
    />
}
